var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlassifizierenImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 480",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "50%",
    y2: "93.187%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4FD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 480,
    display: "none",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.8 268.48) rotate(180) translate(-375 -183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    transform: "translate(375.05 182.68) rotate(180) translate(-375.05 -182.68)",
    d: "m749.2 365.08c0-255.72-118.44-364.8-374.15-364.8s-374.15 109.08-374.15 364.8h748.31z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 54.282,
    r: 10.8,
    fill: "#E5EEFF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 689.2,
    cy: 175.48,
    r: 7.2,
    fill: "#F2F5FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    transform: "translate(658 278.68) rotate(150) translate(-658 -278.68)",
    d: "m649.35 281.55c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#C4D2ED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.402,
    cy: 242.68,
    r: 7.2,
    fill: "#D7DBE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 73.2,
    r: 6,
    fill: "#D7DBE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.15 166.35c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#D9E4F7"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(146.8 319.48) rotate(163) translate(-146.8 -319.48)",
    d: "m141.26 321.81c-1.9825-6.3548 6.1953-11.464 10.284-5.7318 3.7172 5.2334-2.4781 11.339-7.8061 8.5977-2.1064-1.1214-3.965 2.1183-1.8586 3.2397 9.0451 4.735 18.958-5.981 12.391-14.33-6.6909-8.5977-19.701-0.87223-16.603 9.2207 0.74344 2.2429 4.3367 1.3706 3.5933-0.99684z",
    fill: "#C7D5EE"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(617.2 144.28) rotate(-15) translate(-617.2 -144.28)",
    d: "m603.36 150.11c-4.9562-15.887 15.488-28.659 25.711-14.33 9.293 13.083-6.1953 28.348-19.515 21.494-5.266-2.8036-9.9125 5.2957-4.6465 8.0993 22.613 11.837 47.394-14.953 30.977-35.824-16.727-21.494-49.253-2.1806-41.509 23.052 1.8586 5.6072 10.842 3.4266 8.9832-2.4921z",
    fill: "#F3F6FE"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(43.602 115.48) rotate(30) translate(-43.602 -115.48)",
    d: "m34.954 118.35c-2.3172-8.8588 8.4627-16.207 15.213-8.9594 6.75 7.2481-1.4104 17.415-10.075 14.496-1.8134-0.60401-2.6194 2.3154-0.80597 2.9194 11.687 3.926 21.761-10.268 12.996-19.53-8.7649-9.3621-23.373 0.10067-20.25 11.879 0.50373 1.9127 3.4254 1.1073 2.9216-0.80534z",
    fill: "#F4F7FE"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.6 84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    transform: "translate(119.05 177.28) rotate(-7) translate(-119.05 -177.28)",
    d: "m220.56 55.141 3.0095 213.63v21.395c0 6.8925-5.5875 12.48-12.48 12.48h-184.08c-6.8925 0-12.48-5.5875-12.48-12.48v-230.81c0-3.4463 2.7937-6.24 6.24-6.24h0.065307l15.252 0.15998m12.333 0.12909 14.401 0.15072",
    fill: "#fff",
    stroke: "#5374A5",
    strokeLinecap: "round",
    strokeWidth: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    transform: "translate(120.34 178.45) rotate(-7) translate(-120.34 -178.45)",
    d: "m211.25 67.25 2.6951 193.6v19.389c0 6.2463-5.0037 11.31-11.176 11.31h-164.85c-6.1724 0-11.176-5.0637-11.176-11.31v-208.65c0-3.4463 2.7937-6.24 6.24-6.24h20.393",
    fill: "#E2ECFF"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m212.89 3.9c2.2746 0 4.4562 0.90323 6.0651 2.5111l41.943 41.917c1.6102 1.6092 2.5149 3.7924 2.5149 6.0689v195.2c0 2.3693-0.96035 4.5143-2.513 6.067-1.5527 1.5527-3.6977 2.513-6.067 2.513h-184.08c-2.3693 0-4.5143-0.96035-6.067-2.513-1.5527-1.5527-2.513-3.6977-2.513-6.067v-237.12c0-2.3693 0.96035-4.5143 2.513-6.067 1.5527-1.5527 3.6977-2.513 6.067-2.513z",
    fill: "#fff",
    stroke: "#5374A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.28 7.4968v36.183c0 5.1694 4.1906 9.36 9.36 9.36h24.753",
    stroke: "#5374A5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 95.716,
    x2: 176.84,
    y1: 53.04,
    y2: 53.04,
    stroke: "#79A3FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#5374A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 95.716,
    x2: 229.88,
    y1: 90.48,
    y2: 90.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.716,
    x2: 229.88,
    y1: 131.04,
    y2: 131.04
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.716,
    x2: 229.88,
    y1: 171.6,
    y2: 171.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.716,
    x2: 176.84,
    y1: 212.16,
    y2: 212.16
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(424.8 242.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.406,
    cy: 58.406,
    r: 58.406,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.1885 7.1885)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.96,
    cy: 49.998,
    rx: 42.64,
    ry: 42.718,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.9278e-14 50.96c0 28.145 22.816 50.96 50.96 50.96 28.145 0 50.96-22.816 50.96-50.96-0.082278-28.11-22.85-50.878-50.96-50.96-28.145 0-50.96 22.816-50.96 50.96zm18.044-2.6093c2.0229-2.0229 5.3026-2.0229 7.3255-4.8e-5 8e-6 8e-6 1.61e-5 1.6e-5 2.41e-5 2.4e-5l15.153 15.153 36.052-36.052c2.0229-2.0229 5.3026-2.0229 7.3255 0l6e-6 6e-6c2.0218 2.0219 2.0218 5.2999-1.2e-5 7.3218-6.323e-4 6.323e-4 -0.0012648 0.0012645-0.0018975 0.0018965l-38.314 38.275c-2.8103 2.8021-7.3598 2.801-10.169-0.0026453l-17.371-17.371c-2.0229-2.0229-2.0229-5.3027-2.23e-5 -7.3256z",
    fill: "#5374A5",
    stroke: "#fff",
    strokeWidth: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlassifizierenImg);
export default __webpack_public_path__ + "static/media/Klassifizieren_img.3be5fbe3786d292bbe9257dc1e459eda.svg";
export { ForwardRef as ReactComponent };